// TODO: refactor to safely use it for words with more complex plural version f.i. policy, consider ability to force pluralization without count
const pluralize = (word: string, count: number) => (count === 1 ? word : `${word}s`);
const pluralizeVerb = (word: string, count: number) => (count === 1 ? `${word}s` : word);
const pluralizeNext = (count: number, word: string, plural?: string) => {
  const pluralized = plural || `${word}s`;
  return `${count} ${count === 1 ? word : pluralized}`;
};

export { pluralize, pluralizeVerb, pluralizeNext };
